import Vuex from "vuex";
import Vue from "vue";

import game from "./modules/game";
import user from "./modules/user";
import pay from "./modules/pay";
import adConfig from "./modules/adConfig";

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    game,
    user,
    pay,
    adConfig
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/vuex/index.js